module.exports = __webpack_public_path__ + "static/auth0-table-basic-e4ab07cfafe4f21a4a2125e53aa1ed73.png";